import { Home, RefreshCcw, LineChart, KeyRound } from "lucide-react";
import { Reveal } from "./Reveal";

const SERVICES = [
  {
    id: "service-residential",
    icon: Home,
    title: "Home Loans",
    body: "First homes, forever homes and everything between — financed with structures shaped around how you actually earn and live.",
  },
  {
    id: "service-refinance",
    icon: RefreshCcw,
    title: "Refinancing",
    body: "Re-pricing, equity release and restructures that turn dormant property wealth into working capital.",
  },
  {
    id: "service-investment",
    icon: LineChart,
    title: "Investment Lending",
    body: "Multi-property strategies with lender sequencing designed to keep your borrowing capacity alive.",
  },
  {
    id: "service-complex",
    icon: KeyRound,
    title: "Complex & Self-Employed",
    body: "Trusts, companies, variable income and one-off events — presented to credit teams in their own language.",
  },
];

export const Services = () => (
  <section
    id="services"
    data-testid="services-section"
    className="py-32 md:py-48 bg-[#F1EAE1] border-y border-black/[0.06]"
  >
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-end mb-20 md:mb-28">
        <Reveal className="md:col-span-7">
          <p
            data-testid="services-overline"
            className="text-xs font-semibold tracking-[0.35em] uppercase text-[#CFAEA5] mb-6"
          >
            What We Arrange
          </p>
          <h2
            data-testid="services-heading"
            className="font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight leading-tight text-balance"
          >
            Lending, tailored like <em className="italic text-[#CFAEA5]">couture.</em>
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="md:col-span-4 md:col-start-9">
          <p className="text-base leading-relaxed tracking-wide text-[#908B85]">
            Four disciplines, one standard: nothing off the rack.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {SERVICES.map((s, i) => (
          <Reveal key={s.id} delay={i * 0.08}>
            <div
              data-testid={s.id}
              className="group h-full rounded-[4px] border border-black/[0.08] bg-white p-8 md:p-10 transition-[border-color,transform,box-shadow] duration-500 hover:-translate-y-1 hover:border-[#DBB89C]/50 hover:shadow-[0_4px_40px_-10px_rgba(0,0,0,0.08)]"
            >
              <s.icon
                size={28}
                strokeWidth={1.25}
                className="text-[#CFAEA5] mb-10 transition-transform duration-500 group-hover:scale-110"
              />
              <h3 className="font-display text-xl sm:text-2xl font-medium mb-4">
                {s.title}
              </h3>
              <p className="text-sm leading-relaxed tracking-wide text-[#908B85]">
                {s.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1} className="mt-32 md:mt-44">
        <blockquote
          data-testid="testimonial-quote"
          className="max-w-4xl border-l border-[#DBB89C]/60 pl-8 md:pl-14"
        >
          <p className="font-display italic font-medium text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight text-balance">
            “Caitlin didn't find us a loan. She{" "}
            <span className="text-[#CFAEA5]">crafted</span> one.”
          </p>
          <footer className="mt-8 text-xs font-semibold tracking-[0.3em] uppercase text-[#908B85]">
            Private Client — Melbourne
          </footer>
        </blockquote>
      </Reveal>
    </div>
  </section>
);
